type MixpanelWindow = Window & {
    mixpanel?: { start_session_recording?: () => void };
};

const RETRY_MS = 500;
const MAX_ATTEMPTS = 20;

let started = false;

export function startSessionReplay(attempt = 0) {
    if (started) return;
    if (typeof window === "undefined") return;

    const mixpanel = (window as MixpanelWindow).mixpanel;
    if (!mixpanel?.start_session_recording) {
        if (attempt < MAX_ATTEMPTS) {
            window.setTimeout(() => startSessionReplay(attempt + 1), RETRY_MS);
        }
        return;
    }

    try {
        mixpanel.start_session_recording();
        started = true;
    } catch (e) {
        console.warn("Failed to start Mixpanel session replay:", e);
    }
}
